<div class="active-business-bars w-full card-bg rounded-lg duration-200 p-6 relative">
  <!-- Header with Title and Dropdowns -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
    <h2 class="text-lg font-medium text-[#141437] dark:text-white uppercase">Active Businesses Over Time</h2>

    <!-- Filters -->
    <div class="flex flex-wrap items-center gap-3">
      <!-- Year Selection -->
      <div class="flex items-center gap-2">
        <label class="text-sm font-medium text-slate-700 dark:text-slate-300 whitespace-nowrap">Show Years</label>
        <app-dropdown #yearDropdown [options]="yearOptions" [placeholder]="'Select Years'" [selectionMode]="'multiple'"
          [size]="'sm'" [variant]="'outline'" [searchable]="false" [maxSelections]="3" [customWidth]="'200px'"
          [selectionStyle]="'checkbox'" [showApplyButton]="true" [applyButtonText]="'Apply'"
          (selectionChange)="onYearChange($event)">
        </app-dropdown>
      </div>

      <!-- Month Selection -->
      <div class="flex items-center gap-2">
        <app-dropdown #monthDropdown [options]="monthOptions" [placeholder]="'All Months'" [selectionMode]="'multiple'"
          [size]="'sm'" [variant]="'outline'" [searchable]="false" [customWidth]="'180px'" [selectionStyle]="'checkbox'"
          [showApplyButton]="true" [applyButtonText]="'Apply'" [selectedValue]="selectedMonth"
          [displayFormatter]="monthDisplayFormatter" (selectionChange)="onMonthChange($event)">
        </app-dropdown>
      </div>
    </div>
  </div>

  <!-- Chart Container -->
  <div class="chart-wrapper w-full h-[400px]">
    <app-multiple-bar [data1]="chartData1" [data2]="chartData2" [data3]="chartData3" [legendData]="legendData"
      [valueKey]="'total'" [valueType]="'number'" [addGradient]="true" [showDynamicxAxisLabel]="true"
      [barTextposition]="'top'">
    </app-multiple-bar>
  </div>
  @if(isLoading()){
  <app-individual-toaster></app-individual-toaster>
  }
</div>